import { UPDATE_BUSINESS, UPDATE_BUSINESS_SUCCESS, UPDATE_BUSINESS_ERROR, UPDATE_BUSINESS_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateBusiness = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BUSINESS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_BUSINESS_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case UPDATE_BUSINESS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_BUSINESS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateBusiness;
